import JobCreateInfoSidebar from 'components/JobCreateInfoSidebar';
import type { FunctionComponent } from 'react';
import { TITLE, DESCRIPTION } from './Info-constants';

const Info: FunctionComponent = function () {
  return <JobCreateInfoSidebar title={TITLE} description={DESCRIPTION} />;
};

export default Info;
